export default __webpack_public_path__ + "static/media/main_menu_background.f7d244f3.png";